const searchModal = document.querySelector("[data-search-modal]");
const searchModalButton = document.querySelector("[data-search-modal-button]");
const searchModalInput = document.querySelector("[data-search-modal-input]");

if (searchModalButton) {
  searchModalButton.addEventListener("click", () => {
    searchModal.showModal();
  });
}

if (searchModal) {
  searchModal.addEventListener("click", (e) => {
    const dialogDimensions = searchModal.getBoundingClientRect();
    if (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) {
      searchModal.close();
    }
  });
};